// Shared KRW display formatting.
//
// This ONLY formats a number the server already computed — nothing here
// derives a price. See ManageMembershipPage.jsx / product_catalogue.py:
// *** PRICES NEVER COME FROM THE CLIENT. ***
export function formatKrw(n) {
  return '₩' + Number(n || 0).toLocaleString('ko-KR');
}
